import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbSymbol from "../ui-kit/dfb_symbol"
import Section from "./section"
import { formatDate } from "../utilities"

const MHeroBlank = (props) => {
  return (
    <Section
      baseClass="m-Hero m-Hero--blank"
      data={props.data}
    >
      <div className="m-Hero-wrapper">
        <div className="m-Hero-container">
          {props.data.overline && (
            <DfbHeadline headline={props.data.overline} headline_level="h1" add_class="m-Hero-overline" />
          )}
          {props.data.headline && (
            <DfbHeadline headline={props.data.headline} headline_level="h2" add_class="m-Hero-headline" />
          )}
          {props.data.subline && (
            <DfbHeadline headline={props.data.subline} headline_level="h3" add_class="m-Hero-subline" />
          )}
          {props.data.date && (
            <div className="m-Hero-info">
              <div className="dfb-Icon m-Hero-icon">
                <DfbSymbol icon_type="When" />
              </div>
              <div>{formatDate(props.data.date)}</div>
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

export default MHeroBlank
